import { render, staticRenderFns } from "./WawaAction.vue?vue&type=template&id=19f3823a&scoped=true&"
import script from "./WawaAction.vue?vue&type=script&lang=js&"
export * from "./WawaAction.vue?vue&type=script&lang=js&"
import style0 from "./WawaAction.vue?vue&type=style&index=0&id=19f3823a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f3823a",
  null
  
)

component.options.__file = "WawaAction.vue"
export default component.exports